//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'MainLayout',
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    bgImage: get('theme/bgImageShare'),
    backgroundStyle: function backgroundStyle() {
      return {
        background: "linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ")")
      };
    }
  }
};